import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";

const isDuplicateCNIC = async (CNIC, client_id = "") => {
  /**
   * input:
   *  authProvider: email | phone
   * output: bool
   * description: checks if phone number exists
   */

  try {
    const leadsCollection = await collection(
      db,

      "leads"
    );
    const q = query(
      leadsCollection,
      where("cnic", "==", CNIC),
      where("bid", "==", getLocalStorageItem("bid")),
      where("is_deleted", "==", false)
    );
    const leadSnapshot = await getDocs(q);
    if (leadSnapshot.docs.length === 0) return false;
    else if (client_id !== "" && client_id === leadSnapshot.docs[0].id)
      return false;
    else return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default isDuplicateCNIC;
